import { useFormContext } from "react-hook-form";
import { useDataTableQuery } from "./useDataTableQuery";

const useBusy = () => {
  const { query, isPending } = useDataTableQuery();
  const form = useFormContext();
  if (form) {
    return query.isFetching || form.formState.isSubmitting || isPending;
  }
  return query.isFetching || isPending;
};

export default useBusy;
